// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './SwitchesPanelItem';



// WEBPACK FOOTER //
// ./components/SwitchesPanelItem/index.js